export default import.meta.ROLLUP_FILE_URL_EsSyonNWXFChOyjfj2S3nw;